import React from 'react'
import { UserProfileModel, WSChatMessage } from 'mvppoker-portal-common/api'
import './FriendsChatListItem.scss'

export interface FriendsChatListItemProps
{
    userId: string,
    userAvatar: string,
    friendProfile: UserProfileModel,
	chatMessage: WSChatMessage
}
const userColor = '#008000'

export const FriendsChatListItem: React.FC<FriendsChatListItemProps> = ({ userId, userAvatar, friendProfile, chatMessage }) =>
{
    const { fromId, message, timestamp, cards } = chatMessage

    const isUserMessage = fromId === userId
    const marginLeft = isUserMessage ? '40px' : '0px'
    const marginRight = isUserMessage ? '0px' : '40px'
    const avatar = isUserMessage ? userAvatar: friendProfile.info.avatar
    const name = isUserMessage ? 'You' : friendProfile.info.name
    const messageLabelClass = isUserMessage ? 'user' : ''

    const getFriendColor = (id: string) : string => {
        // TODO: generate hash
        return '#000080'
    }

    const backgroundColour = isUserMessage ? userColor : getFriendColor(fromId)

	return (
		<div className='friends-chat-list-item mvp-list-item' style={{ backgroundColor: backgroundColour, marginLeft, marginRight  }}>
            <img className='avatar' src={avatar} alt='avatar'/>
            <p id="date-label">{`${new Date(timestamp).toLocaleTimeString()}`}</p>
            <p id="name-label">{name}</p>
            <p id="message-label" className={messageLabelClass}>{message}</p>
		</div>
	)
}
